import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { loadFinancedOffers } from 'features/folder/edit/generalData/financedOffers/actionCreators';
import { getFinancedOffers } from 'features/folder/edit/generalData/financedOffers/selectors';
import { GET_FOLDER_HEADER_ALPHA_QUERY } from 'features/folder/edit/generalData/info/queries';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { getInt } from 'utils/functions';
import Assignment from '@mui/icons-material/Assignment';
import DocumentsContainer from 'features/document/edit/documents/components/DocumentsContainer';
import { Card } from '@totalsoft/rocket-ui';

const FolderDocumentsCardAlpha = ({ documentId, siteId, onDocumentsHistoryClick, financedOffers, t }) => {
  const { data } = useQueryWithErrorHandling(GET_FOLDER_HEADER_ALPHA_QUERY, {
    variables: { documentId: getInt(documentId), siteId: getInt(siteId) },
    skip: !documentId
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!documentId) return;
    dispatch(loadFinancedOffers(documentId, siteId));
  }, [documentId, siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!documentId) return;
    dispatch(loadFinancedOffers(documentId, siteId));
  }, [documentId, financedOffers]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {financedOffers?.map(financedOffer => {
        return (
          <Card icon={Assignment} key={financedOffer.offerId} title={`${t('OfferList.OfferNumber')}:${financedOffer.documentNumber}`}>
            <DocumentsContainer
              documentId={financedOffer.currentOfferId}
              siteId={financedOffer.currentOfferSiteId}
              onDocumentsHistoryClick={onDocumentsHistoryClick}
              documentNumber={financedOffer.documentNumber}
              clientDefaultEmail={data?.folderHeaderAlpha?.client?.defaultEmail}
            />
          </Card>
        );
      })}
    </>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    financedOffers: getFinancedOffers(state, ownProps.documentId, ownProps.siteId)
  };
}

FolderDocumentsCardAlpha.propTypes = {
  t: PropTypes.func.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  onDocumentsHistoryClick: PropTypes.func.isRequired,
  financedOffers: PropTypes.array
};

export default compose(withTranslation(), connect(mapStateToProps))(FolderDocumentsCardAlpha);
